export const isServer = import.meta.server
export const spritePaths = Object.freeze({
  "default": "/_nuxt-clientportal/nuxt-svg-icon-sprite/sprite-default.G-0T2tErJdbwENomSFd6n0A8EA0KfPRwm2-QE_nFW6c.svg",
  "sidebar": "/_nuxt-clientportal/nuxt-svg-icon-sprite/sprite-sidebar.Ct8uebB4tr-IdFpdxFOlWShiv38MzFA6A-xK4m5iJIs.svg",
  "leaderboard": "/_nuxt-clientportal/nuxt-svg-icon-sprite/sprite-leaderboard.qcETGgunkY80jFZ4ysDjDOjHhA6srSulaMfI4ujTqhM.svg"
});
export const runtimeOptions = Object.freeze({
  "ariaHidden": false
});
export const allSymbolNames = Object.freeze([
  "audio-file",
  "excel-file",
  "file",
  "image-file",
  "invoices-empty",
  "leaderboard/leaderboard-first-place",
  "leaderboard/leaderboard-second-place",
  "leaderboard/leaderboard-third-place",
  "pdf-file",
  "resource-empty",
  "sidebar/affiliates",
  "sidebar/affiliates-active",
  "sidebar/appointments",
  "sidebar/appointments-active",
  "sidebar/communities",
  "sidebar/communities-active",
  "sidebar/contracts",
  "sidebar/contracts-active",
  "sidebar/courses",
  "sidebar/courses-active",
  "sidebar/dashboard",
  "sidebar/dashboard-active",
  "sidebar/documents",
  "sidebar/documents-active",
  "sidebar/estimates",
  "sidebar/estimates-active",
  "sidebar/explore",
  "sidebar/explore-active",
  "sidebar/invoices",
  "sidebar/invoices-active",
  "sidebar/studio",
  "sidebar/studio-active",
  "text-file",
  "video-file",
  "word-file"
]);